import { Injectable, signal, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, interval, Subscription, catchError, of } from 'rxjs';
import { Banner } from '../models/banner';
import { prodAPI } from '../../../env';

@Injectable({
  providedIn: 'root'
})
export class LiveTradingBannersService implements OnDestroy {
  private apiUrl = `${prodAPI}/api/overlay/live-trading-banners`;
  private bannersSignal = signal<Banner[]>([]);
  private pollingSubscription?: Subscription;
  private readonly POLLING_INTERVAL = 3600000;

  constructor(private http: HttpClient) {
    this.startPolling();
  }

  ngOnDestroy(): void {
    this.stopPolling();
  }

  getBanners() {
    return this.bannersSignal.asReadonly();
  }

  fetchBanners(): Observable<Banner[]> {
    return this.http.get<Banner[]>(this.apiUrl).pipe(
      catchError(err => {
        console.error('API request failed:', err);
        return of([]);
      })
    );
  }

  loadBanners(): void {
    this.fetchBanners().subscribe({
      next: (banners) => {
        const realBanners = banners || [];
        console.log('Live trading banners from API:', realBanners);
        this.bannersSignal.set(realBanners);
      },
      error: (err) => {
        console.error('Failed to load live trading banners:', err);
      }
    });
  }

  private startPolling(): void {
    this.loadBanners();
    this.pollingSubscription = interval(this.POLLING_INTERVAL).subscribe(() => {
      this.loadBanners();
    });
  }

  private stopPolling(): void {
    if (this.pollingSubscription) {
      this.pollingSubscription.unsubscribe();
    }
  }

  refreshBanners(): void {
    this.loadBanners();
  }
}